import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import transformFeatureData from '../utility/transformFeatureData'

// Redux type and action creators
const { Types, Creators } = createActions({
  chartPanelToggled: [],
  chartsReset: [],
  chartDataUpdated: ['featureData'],
  chartRenderToggled: ['chartName'],
  chartRenderRemoved: ['chartName'],
  reset: []
})

export const ChartTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  chartPanelOpen: false,
  chartsRendered: [],
  data: {}
})

// Redux reducers
export const chartPanelToggled = state => {
  const { chartPanelOpen } = state

  return state.merge({ chartPanelOpen: !chartPanelOpen })
}

export const chartRenderToggled = (state, { chartName }) => {
  const { chartsRendered } = state
  const nextChartsRendered =
    chartsRendered.indexOf(chartName) >= 0
      ? chartsRendered.filter(chart => chart !== chartName)
      : [chartName, ...chartsRendered]
  return state.merge({ chartsRendered: nextChartsRendered })
}

export const chartRenderRemoved = (state, { chartName }) => {
  const { chartsRendered } = state
  const nextChartsRendered = chartsRendered.filter(chart => chart !== chartName)
  return state.merge({ chartsRendered: nextChartsRendered })
}

export const chartDataUpdated = (state, { featureData }) => {
  const { data } = state
  const nextData = transformFeatureData(featureData)
  const nextChartsRendered = Object.keys(nextData)
  return state.merge({
    data: data.merge(nextData),
    chartsRendered: nextChartsRendered
  })
}

export const chartsReset = state => {
  return INITIAL_STATE
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.CHART_PANEL_TOGGLED]: chartPanelToggled,
  [Types.CHART_RENDER_TOGGLED]: chartRenderToggled,
  [Types.CHART_RENDER_REMOVED]: chartRenderRemoved,
  [Types.CHART_DATA_UPDATED]: chartDataUpdated,
  [Types.CHARTS_RESET]: chartsReset,
  [Types.RESET]: chartsReset
})



// WEBPACK FOOTER //
// ./src/redux/chartRedux.js